import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './loader.scss?inline';

export default class SotbitLoader extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        text: { type: String },
        inline: { type: Boolean },
        fixed: { type: Boolean },
        size: { type: String },
    };

    constructor() {
        super();

        this.text = '';
        this.size = 'm';
    }

    render() {
        return html`<div class="loader-wrapper" part="loader-wrapper">
            <span class="loader" part="loader">
                <sotbit-icon
                    class="loader-icon"
                    icon="loader"
                    size="${this.size}"
                    no-padding
                    part="loader-icon"
                ></sotbit-icon>
            </span>
            ${this.text ? html`<span class="loader-text" part="loader-text">${this.text}</span>` : html``}
        </div>`;
    }
}
